<div class="fd-modal-content">
  <h3 fxLayoutAlign="center">Novo profile</h3>
  <form [formGroup]="formGroup">
    <div fxLayout="column" fxLayoutAlign="center">
      <div fxLayoutGap="20px">
        <div fxFlex="100">
          <fd-select [parentForm]="formGroup" [field]="fields.institutionNumber"
            (selectionChange)="selectedInstitution()">
          </fd-select>
        </div>
      </div>
      <div fxLayoutGap="20px">
        <div fxFlex="100">
          <fd-select [parentForm]="formGroup" [field]="fields.serviceContract">
          </fd-select>
        </div>
      </div>
      <div fxLayoutGap="20px">
        <div fxFlex="100">
          <fd-input [parentForm]="formGroup" [field]="fields.name" ></fd-input>
        </div>
      </div>
      <h5>Permissões</h5>
      <div fxLayoutGap="20px">
        <div class="fd-label__container">
          <div *ngIf="formGroup.controls.roles.hasError('required') && formGroup.controls.roles.touched" class="mat-mdc-form-field-error mat-error">
            {{fields?.roles.messages?.required}}
          </div>
        </div>
      </div>
      <!-- Using fxFlex="50" for permissions layout in add-profile; see update-profile.component.html for layout difference notes -->
      <div fxLayoutGap="20px">
        <div fxFlex="50">
          <div *ngFor="let item of roles; let i = index" class="checkbox-item">
            <mat-checkbox (change)="onCheckboxChange(item, $event)" [value]="item.value" [checked]="item.selected" class="fd-checkbox" [id]="item.value">{{item.label}}</mat-checkbox>
          </div>
        </div>
      </div>
    </div>
  </form>

  <div mat-dialog-actions >
    <div style="width: 100%; align-content: center">
      <fd-button mat-button fdSecondaryLarge [content]="'Cancelar'" (trigger)="close()"> </fd-button>
      <fd-button fdPrimaryLarge mat-flat-button [content]="'Salvar'" (trigger)="save()"> </fd-button>
    </div>
  </div>
</div>
